import { createApp } from 'vue'
import App from './App.vue'
import shell from 'vue-shell'

const app = createApp(App)
app.use(shell);
app.mount('#app')